
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import {getBrandList, getAreaId} from "../../../api/kookong";
import {windVane} from "../../../utils/tmallGenius";

const COUNTRY_CODE = "CN";
export default {
name: "brandList",
components: {
Group,
Cell,
CellFormPreview,
CellBox,
Badge,
InlineLoading
},
data() {
return {
keyword: "",
list: [],
filteredList: [],
urlData: {},
loading: true,
cityId: undefined
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("请选择品牌");
next();
},
created() {
const data = {
deviceType: this.$route.query.kookongDeviceType,
countryCode: COUNTRY_CODE,
lanCode: "zh"
};
getBrandList(data).then(res => {
this.list = res.data;
this.filteredList = this.list;
this.loading = false;
});
this.getCityId();
},
methods: {
getTitle() {
const data = {
2: "电视机",
8: "风扇",
4: "空调",
5: "空调"
};
return data[this.$route.query.kookongDeviceType];
},
gotoPanel: function (item) {

const router = {
1: "/device/tvbox",
2: "/device/tv",
8: "/device/fan",
4: "/device/air",
5: "/device/air"
};
this.$router.push({
path: router[this.$route.query.kookongDeviceType],
query: {
bid: item.brandId,
kookongDeviceType: this.$route.query.kookongDeviceType,
uid: this.$route.query.uid,
deviceId: this.$route.query.deviceId,
deviceType: this.$route.query.deviceType,
aligenieZone: this.$route.query.aligenieZone,
areaId: this.cityId,
countryCode: COUNTRY_CODE
}
});
},

filterBrand: function () {
const reg = new RegExp(this.keyword, "gi");
const list = this.list.filter(item => {
return reg.test(item.cname) || reg.test(item.ename);
});
this.filteredList = list;
},

/**
* 获取城市代号
*/
getCityId() {
windVane
.getLocation()
.then(res => {
const {province, city} = res;

const params = {province, city};
getAreaId(params).then(res => {
if (res.status === 0) {
this.cityId = res.data.cityId;
} else {
alert(res.message);
}
}).catch(e => {
alert(e);
});
})
.catch(e => {
console.error(JSON.stringify(e));
alert("请授权定位权限");
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/tv/BrandList.vue